// Client for the editor "local history" — per-tab version snapshots.
import { api } from './api.js';

// Snapshot the current buffer for a tab. Fire-and-forget at the call site; the
// server dedupes a no-change snapshot and prunes old ones.
export const addEditorVersion = (payload) => api.post('/api/me/editor-history', payload);

// List a tab's versions (newest first).
export const listEditorVersions = (tabKey) =>
  api.get(`/api/me/editor-history?tabKey=${encodeURIComponent(tabKey)}`).then((r) => r.versions || []);
